module.exports = __webpack_public_path__ + "img/goal06.0ed19abd.png";